// Task #4004 / #4041 — Mercury credit-card "near its limit" threshold helpers.
// Defined in `shared/` so the in-page P&L warning (client) and the push-style
// near-limit alert (server cron / refresh) compute utilization the exact same
// way and can never disagree about when a card is "maxed out".

// Utilization threshold at which a Mercury credit card is flagged as "near its
// limit". >80% utilization (i.e. ≤20% of the limit still available) is the
// default warning point so hosts can proactively avoid declined vendor
// payments.
export const MERCURY_CREDIT_NEAR_LIMIT_UTILIZATION = 0.8;

// Fraction of the credit limit currently used (outstanding / limit). Returns 0
// when there is no usable limit so a missing/zero limit never reads as maxed.
export function mercuryCardUtilization(row: { outstandingBalance: number; creditLimit: number }): number {
  if (!(row.creditLimit > 0)) return 0;
  return row.outstandingBalance / row.creditLimit;
}

export function isMercuryCardNearLimit(row: { outstandingBalance: number; creditLimit: number }): boolean {
  return mercuryCardUtilization(row) >= MERCURY_CREDIT_NEAR_LIMIT_UTILIZATION;
}
